import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { BarChart } from "@mui/x-charts/BarChart";
import {
  Button,
  Container,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  createTheme,
  ThemeProvider,
  useTheme,
  Tooltip,
  Dialog,
} from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { Autocomplete } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import { UrlApiEnvasado } from "../../../../services/apirest";

// IMPORTS
import TableGrafica4 from "../TableGrafica4";
import ChartGrafica4 from "../ChartGrafica4";

// PARA EL IDIOMA DEL CALENDARIO
import "dayjs/locale/es";
import dayjs from "dayjs";

// ICONOS
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CircularProgress from '@mui/material/CircularProgress';

export default function Grafica4Expandida() {
  const [sucursales, setSucursales] = useState([]);
  const [choferes, setChoferes] = useState([]);
  const [choferesVentas, setChoferesVentas] = useState([]);
  const [openDialogTable, setopenDialogTable] = useState();
  const [datosChoferVentas, setDatosChoferVentas] = useState();
  const [loading, setLoading] = useState(true)

  // const [visibleBars, setVisibleBars] = useState(12); // Número inicial de barras visibles
  // const [filteredMonths, setFilteredMonths] = useState([]);

  // const handleVisibleBarsChange = (event, newValue) => {
  //   setVisibleBars(newValue);
  // };

  // const handleMonthCheckboxChange = (month) => {
  //   setFilteredMonths((prevMonths) =>
  //     prevMonths.includes(month)
  //       ? prevMonths.filter((m) => m !== month)
  //       : [...prevMonths, month]
  //   );
  // };

  // ------------------------------------------------------------------------

  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  // CAMBIO DE FECHA
  const handleYearChange = (newDate) => {
    if (dayjs(newDate).isValid()) {
      setSelectedYear(dayjs(newDate).year().toString());
    }
  };

  console.log("AÑO SELECCIONADO: ", selectedYear);

  // ------------------------------------------------------------------------

  // FECHA DE HOY
  const hoy = dayjs();

  // **************************************************************************

  // ******************
  // **** BORRAR ? ****
  // ******************

  // SUCURSALES
  const obtenerSucursales = () => {
    fetch(UrlApiEnvasado + "/envasado/sucursales")
      .then((data) => data.json())
      .then((data) => setSucursales(data));
  };

  useEffect(() => {
    obtenerSucursales();
  }, []);

  console.log("Sucursales: ", sucursales);

  // CHOFERES
  const obtenerChoferes = () => {
    fetch(UrlApiEnvasado + "/envasado/choferes")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error al obtener los choferes");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Choferes obtenidos:", data);
        setChoferes(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    obtenerChoferes();
    console.log("EJECUTO OBTENER CHOFERES");
  }, []);

  console.log("Choferes: ", choferes);

  // **************************************************************************

  // SUCURSAL
  // const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);

  // const handleSucursalChange = (sucursal) => {
  //   setSucursalSeleccionada(sucursal);
  // };

  // CHOFER
  // const [choferSeleccionado, setChoferSeleccionado] = useState(null);

  // const handleChoferChange = (chofer) => {
  //   setChoferSeleccionado(chofer);
  // };

  // **************************************************************************

  console.log("HOY:", hoy);

  // VENTAS DE LOS CHOFERES
  const obtenerChoferesVentas = () => {
    setLoading(true); // Iniciar carga

    fetch(
      UrlApiEnvasado + "/envasado/choferes/totalventas/anio/" + selectedYear
    )
      .then((data) => data.json())
      .then((data) => {
        setChoferesVentas(data);
        setLoading(false); // Finalizar carga
      })
      .catch((error) => {
        console.error("Error al obtener las ventas de los choferes:", error);
        setLoading(false); // Finalizar carga en caso de error
      });
  };

  useEffect(() => {
    obtenerChoferesVentas();
  }, [selectedYear]);

  console.log("VENTAS DE CHOFERES: ", choferesVentas);

  // **************************************************************************

  // TABLA
  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "id",
        size: 40,
      },
      {
        header: "Vendedor",
        accessorKey: "vendedor_nombre",
        size: 150,
      },
      {
        header: "Sucursal",
        accessorKey: "sucursal_nombre",
        size: 200,
      },
      {
        header: "Peso Total Vendido",
        accessorKey: "peso_total_vendido",
        size: 200,
        Cell: ({ cell }) => `${cell.getValue()} kg`, // Agregar "kg" al final del valor
      },
    ],
    []
  );

  //*************************************************************************************************************************************/

  // ESTILO PARA LA TABLA
  const globalTheme = useTheme();

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      size: 95,
    },
  };

  const tableHeadCellProps = {
    align: "left", // Titulos de la tabla
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    grouping: ["sucursal_nombre"],
    sorting: [
      {
        id: "sucursal_nombre",
        desc: true,
      },
      {
        id: "vendedor_nombre",
        desc: true,
      },
    ],
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  //*************************************************************************************************************************************/

  // ABRIR DIALOG (Props)

  //  DIALOG PARA CARGA DE HALLAZGO
  const handleOpenDialogTable = (row) => {
    setDatosChoferVentas(row.original);
    setopenDialogTable(true);
  };

  const handleCloseDialogChart = () => {
    setopenDialogTable(!openDialogTable);
  };

  //*************************************************************************************************************************************/

  return (
    <div
    // style={{
    //   backgroundColor: "#F2F2F2",
    // }}
    >
      <Container maxWidth="xl" mt={1}>
        <Box mb={4}>
        {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress />
            </div>
          ) : (
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                enableGrouping
                positionActionsColumn="last" // posicion de la columna de acciones al final
                displayColumnDefOptions={displayColumnDefOptions}
                muiTableHeadCellProps={tableHeadCellProps}
                layoutMode="grid"
                enableColumnActions={true}
                enableColumnFilters={false} //desactiva filtros x columna
                enableHiding={false}
                enableDensityToggle={false}
                initialState={initialState}
                columns={columns}
                data={choferesVentas}
                renderTopToolbarCustomActions={() => (
                  <Grid container>
                    <Grid item xs={5}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="es"
                      >
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            views={["year"]}
                            label="Año"
                            value={dayjs(`${selectedYear}`)}
                            onChange={(newDate) => handleYearChange(newDate)}
                            slotProps={{ textField: { size: "small" } }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>{" "}
                    </Grid>
                  </Grid>
                )}
                enableRowActions
                renderRowActions={({ row }) => (
                  <>
                    <Tooltip arrow placement="bottom" title="Ver Detalles">
                      <Button
                        style={{ padding: "6px", minWidth: "auto" }}
                        size="small"
                        onClick={() => handleOpenDialogTable(row)}
                      >
                        <ContentPasteSearchIcon />
                      </Button>
                    </Tooltip>
                  </>
                )}
                renderDetailPanel={({ row }) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <ChartGrafica4
                      datosChoferVentas={row.original}
                      anio={selectedYear}
                    />
                  </div>
                )}
              />
            </ThemeProvider>
          )}
        </Box>
      </Container>

      <Dialog
        open={openDialogTable}
        onClose={handleCloseDialogChart}
        fullWidth
        maxWidth="xl"
      >
        <Box>
          <TableGrafica4 datosChoferVentas={datosChoferVentas} 
          anio={selectedYear} 
          // anio={hoy.$y} 
          />
        </Box>
      </Dialog>
    </div>
  );
}
